import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from 'services';

interface AuthContextType {
  isAuth: boolean;
  login: (email: string, password: string) => Promise<any>;
  logout: () => void;
  forgotPassword: (email: string) => void;
  loginSecure: (
    otpCode: string,
    optType: string,
    setDefault: boolean,
  ) => Promise<any>;
  sendSecureSMS: () => Promise<any>;
}

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

// Export the provider as we need to wrap the entire app with it
export function AuthProvider({ children }: { children: ReactNode }) {
  const [isAuth, setIsAuth] = useState<boolean>(
    !!localStorage.getItem('token'),
  );
  // const navigate = useNavigate();

  async function login(email: string, password: string) {
    return AuthService.login(email, password).then((loginResponse) => {
      localStorage.setItem('token', loginResponse.access_token);
      localStorage.setItem('refreshToken', loginResponse.refresh_token);
      localStorage.setItem('phone', loginResponse.phone_number);
      setIsAuth(!!localStorage.getItem('token'));
      return loginResponse;
    });
  }

  async function loginSecure(
    otpCode: string,
    optType: string,
    setDefault: boolean,
  ) {
    return AuthService.loginSecure(otpCode, optType, setDefault);
  }

  async function logout() {
    await AuthService.logout();
    // localStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('phone');
    localStorage.removeItem('setDefault');
    setIsAuth(!!localStorage.getItem('token'));
    // navigate('/');
  }

  function forgotPassword(email: string) {
    return AuthService.forgotPassword(email);
  }

  function sendSecureSMS() {
    return AuthService.sendSecureSMS();
  }

  const memoedValue = useMemo<AuthContextType>(
    () => ({
      isAuth,
      login,
      loginSecure,
      sendSecureSMS,
      logout,
      forgotPassword,
    }),
    [isAuth],
  );

  return (
    <AuthContext.Provider value={memoedValue}>{children}</AuthContext.Provider>
  );
}

export default function useAuth() {
  return useContext(AuthContext);
}
